export default function AddressModeToggleLink({ onClick, children }) {
    return (
        <p className="has-text-centered mt-2 mb-0">
            <a
                href="#manual-address"
                className="is-underlined is-size-7 has-text-primary"
                onClick={(event) => {
                    event.preventDefault();
                    onClick?.();
                }}
            >
                {children}
            </a>
        </p>
    );
}
